import React from 'react'
import PropTypes from 'prop-types'
import { KnowledgeAroundBoxWrapper } from './KnowledgeAroundBoxStyled'
import { AroundBoxShadow, AroundBoxText, AroundBoxTextMobile } from '../CommonStyled/CommonStyled'
import IMAGES from '../../images'
import { Fade } from 'react-awesome-reveal'

const KnowledgeAroundBox = props => {
  const { data, callBackClick, position, direction } = props

  const getDirection = () => {
    if (!direction.top) return 'down';
    if (!direction.bottom) return 'up';
    if (!direction.left) return 'right';
    if (!direction.right) return 'left';
    return 'up';
  };

  return (
    <KnowledgeAroundBoxWrapper position={position}>
      <Fade
        direction={getDirection()}
        key={data}
        duration={500}
      >
        <AroundBoxShadow onClick={callBackClick}>
          {data.image && <img src={data.image} alt={''} />}
          <AroundBoxTextMobile>{data.label}</AroundBoxTextMobile>
        </AroundBoxShadow>
        <AroundBoxText>{data.label}</AroundBoxText>
      </Fade>
    </KnowledgeAroundBoxWrapper>
  )
}

KnowledgeAroundBox.propTypes = {
  data: PropTypes.object,
  callBackClick: PropTypes.func,
}

export default KnowledgeAroundBox
